import { usePaypalContext, useStripeContext } from '../contexts';
import isEmpty from 'lodash/isEmpty';

export const usePaymentsLoaded = () => {
  const stripeContext = useStripeContext();
  const paypalContext = usePaypalContext();

  return !isEmpty(stripeContext?.stripeStatus) && !isEmpty(paypalContext?.paypalStatus);
};
